/**
 * Adds two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 * @function
 */
module.exports = require('gl-vec4/add')



//////////////////
// WEBPACK FOOTER
// ./~/gl-quat/add.js
// module id = 1334
// module chunks = 0